import { Step, StepButton, StepLabel, Stepper } from "@mui/material";
import React from "react";
import { ProposalStepIcon } from "src/components/ProposalStepper/ProposalStepper";
import "./CampaignStepper.scss";

function getStepActiveState(activeStep: number, index: number) {
  return activeStep == index ? "campaign-stepper__step__active" : "campaign-stepper__step__inactive";
}

export interface IStep {
  label: string;
}

export interface Props {
  steps: IStep[];
  activeStep: number;
  isClassificationLoaded?: boolean;
  onClick: (e: any, stepIndex: number) => any;
}

const CampaignStepper: React.FC<Props> = props => {
  const { steps, onClick, activeStep, isClassificationLoaded } = props;

  return (
    <div className="campaign-stepper">
      <div>
        <Stepper alternativeLabel nonLinear activeStep={activeStep}>
          {steps.map((step, index) => {
            return (
              <Step className="campaign-stepper__step" key={step.label}>
                <StepButton disabled={!isClassificationLoaded} onClick={e => onClick(e, index)}>
                  <StepLabel StepIconComponent={ProposalStepIcon}>
                    <span className={getStepActiveState(activeStep, index)}>{step.label}</span>
                  </StepLabel>
                </StepButton>
              </Step>
            );
          })}
        </Stepper>
      </div>
    </div>
  );
};

export default CampaignStepper;
